import { GA4EventName, trackFilterInteraction } from '@jsmdg/tracking';

async function trackLocationTypeInClicked(
    label: string,
    location: string,
    activeValues: string,
): Promise<void> {
    await window.yieldToMainThread();
    trackFilterInteraction(
        'SetLocation',
        label,
        {
            eventName: GA4EventName.SetFilter,
            filter_type: 'Location via type-in',
            filter_value: location,
            last_location: location,
        },
        activeValues,
    );
}

async function trackLocationTypeInError(label: string, message: string): Promise<void> {
    await window.yieldToMainThread();
    trackFilterInteraction('Error', label, {
        eventName: GA4EventName.ShowNotification,
        notification_type: 'Error - Invalid location',
        notification_message: message,
    });
}

async function trackResetLocationClicked(label: string, activeValues: string): Promise<void> {
    await window.yieldToMainThread();
    trackFilterInteraction(
        'SetLocation',
        label,
        {
            eventName: GA4EventName.ResetFilter,
            filter_type: 'Location',
        },
        activeValues,
    );
}

async function trackLocateMeClicked(
    label: string,
    location: string,
    activeValues: string,
): Promise<void> {
    await window.yieldToMainThread();
    trackFilterInteraction(
        'SetLocation',
        label,
        {
            eventName: GA4EventName.SetFilter,
            filter_type: 'Location via locate-me',
            filter_value: location,
            last_location: location,
        },
        activeValues,
    );
}

async function trackLocateMeError(
    label: string,
    notification: string,
    message: string,
): Promise<void> {
    await window.yieldToMainThread();
    trackFilterInteraction('SetLocation', label, {
        eventName: GA4EventName.ShowNotification,
        notification_type: notification,
        notification_message: message,
    });
}

export {
    trackLocateMeClicked,
    trackLocateMeError,
    trackLocationTypeInClicked,
    trackLocationTypeInError,
    trackResetLocationClicked,
};
